import { render, staticRenderFns } from "./CompanyInformation.vue?vue&type=template&id=47c79212&scoped=true&"
import script from "./CompanyInformation.vue?vue&type=script&lang=js&"
export * from "./CompanyInformation.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInformation.vue?vue&type=style&index=0&id=47c79212&lang=less&scoped=true&"
import style1 from "./CompanyInformation.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c79212",
  null
  
)

export default component.exports